import { jsx as _jsx } from "react/jsx-runtime";
import { faSave } from '@fortawesome/free-regular-svg-icons';
import { errandButtonUtils } from '../../errandButtonUtils';
import { ExecuteActionResult } from '../../ExecuteActionResult';
import { SendToButton } from '../SendTo/SendToButton';
import { hideWhenReadOnlyRule } from '../commonRules';
import { SaveInRegistryModal } from './SaveInRegistryModal';
export const SaveInRegistryButton = {
    key: 'spara_register',
    text: 'Spara',
    prio: 1,
    section: 'start',
    icon: faSave,
    buttonStyle: 'primary',
    ModalComponent: SaveInRegistryModal,
    onClick: async (row, inca, showModal, ctx, api)=>{
        const isValid = await ctx.validate();
        if (!isValid) {
            return;
        }
        const { isSuccess, result: { res, transitionShortname } } = await showModal();
        if (!isSuccess) {
            return;
        }
        const stateTransitionResult = await errandButtonUtils.performStateTransition(transitionShortname, ctx, api, {
            ...res,
            selectedPositionId: res.selectedPositionId ?? inca.user.position.id
        });
        if (!stateTransitionResult) {
            return;
        }
        api.setRootComponent(/*#__PURE__*/ _jsx(ExecuteActionResult, {
            title: "Ärendet sparades i registret",
            isFinished: [
                'Spara_i_register',
                'Klar'
            ].includes(transitionShortname),
            stateTransitionResult: stateTransitionResult
        }));
    },
    defaultRules: [
        hideWhenReadOnlyRule,
        {
            id: 'disableWhenFormIncomplete',
            description: 'Knappen blir disabled för inrapportörer när inkomplett-kryssrutan är ikryssad.',
            evaluateState: (row, inca, ctx)=>{
                if (!inca.user.role.isReviewer) {
                    if (ctx.formIncomplete) {
                        return {
                            state: 'Disabled',
                            tooltip: `Eftersom formuläret inte fyllts i komplett måste det skickas till RCC i din region för handläggning. Använd knappen "${SendToButton.text}"`
                        };
                    }
                }
                return {
                    state: 'Visible'
                };
            }
        },
        {
            id: 'disableWhenSendToActivated',
            description: 'Knappen blir disabled för inrapportörer när activateSendToButton är sann.',
            evaluateState: (row, inca, ctx)=>{
                if (!inca.user.role.isReviewer) {
                    if (ctx.formIncomplete || ctx.options.activateSendToButton) {
                        return {
                            state: 'Disabled',
                            tooltip: `Formuläret är markerat för att skickas till RCC. Använd knappen "${SendToButton.text}"`
                        };
                    }
                }
                return {
                    state: 'Visible'
                };
            }
        },
        {
            id: 'disableWhenDirectUpdateAndOtherErrandsExist',
            description: 'Knappen disableas för inrapportörer vid direktuppdatering då det finns aktiva ärenden kopplade till vald registerpost.',
            evaluateState: (row, inca, ctx)=>{
                if (!inca.user.role.isReviewer && ctx.connectionState) {
                    const isDirectCompletion = ctx.connectionState.metadata.completion.isCompletion && ctx.connectionState.metadata.completion.type === 'DIRECT';
                    const hasConnectedErrands = ctx.connectionState.metadata.completion.hasConnectedErrands;
                    if (isDirectCompletion && hasConnectedErrands) {
                        return {
                            state: 'Disabled',
                            tooltip: `Uppdateringen ska skickas till RCC då det redan finns aktiva ärenden kopplade till registerposten. Använd knappen "${SendToButton.text}"`
                        };
                    }
                }
                return {
                    state: 'Visible'
                };
            }
        },
        {
            id: 'disableWhenDirectUpdateAndRrChanged',
            description: 'Knappen disableas för inrapportörer vid direktuppdatering när inläst registerpost har ändrats.',
            evaluateState: (row, inca, ctx)=>{
                if (!inca.user.role.isReviewer && ctx.connectionState) {
                    const isDirectCompletion = ctx.connectionState.metadata.completion.isCompletion && ctx.connectionState.metadata.completion.type === 'DIRECT';
                    const completedRrChanged = ctx.connectionState.metadata.completion.rrChanged;
                    if (isDirectCompletion && completedRrChanged) {
                        return {
                            state: 'Disabled',
                            tooltip: `Uppdateringen ska skickas till RCC då registerposten har uppdaterats sen den lästes in i ärendet. Använd knappen "${SendToButton.text}"`
                        };
                    }
                }
                return {
                    state: 'Visible'
                };
            }
        },
        {
            id: 'disableWhenUnconnectedAndAllowUnconnectedSaveIsFalse',
            description: 'Knappen disableas för inrapportörer om allowUnconnectedSave = false och posten är okopplad.',
            evaluateState: (row, inca, ctx)=>{
                if (!inca.user.role.isReviewer && ctx.connectionState) {
                    const isDirectCompletion = ctx.connectionState.metadata.completion.isCompletion && ctx.connectionState.metadata.completion.type === 'DIRECT';
                    if (!isDirectCompletion && !ctx.connectionState.metadata.allowUnconnectedSave && !ctx.connectionState.isConnected && !ctx.connectionState.isConnectedForUpdate) {
                        return {
                            state: 'Disabled',
                            tooltip: `Du kan inte spara direkt i registret då formuläret ska kopplas till ${ctx.connectionState.metadata.formName.parent}. Koppla formuläret eller använd knappen "${SendToButton.text}"`
                        };
                    }
                }
                return {
                    state: 'Visible'
                };
            }
        }
    ],
    superConnectionRules: [
        {
            id: 'disableWhenUnconnectedAndConnectionRequired',
            description: 'Knappen disableas för inrapportörer om connectionRequired = true och posten är okopplad.',
            evaluateState: (row, inca, ctx)=>{
                if (!inca.user.role.isReviewer && inca.form.designedForm.useRegisterRecordConnections) {
                    if (!ctx.superConnectionState?.isConnected && ctx.superConnectionState?.isRequired) {
                        return {
                            state: 'Disabled',
                            tooltip: `Du kan inte spara direkt i registret då formuläret ska kopplas. Koppla formuläret eller använd knappen "${SendToButton.text}"`
                        };
                    }
                }
                return {
                    state: 'Visible'
                };
            }
        }
    ]
};
